import { NgModule } from "@angular/core";
import { PageNotFoundComponent } from "./not-found/not-found.component";
import { UncaughtErrorComponent } from "./error/uncaught-error.component";
import { TranslateModule } from "@ngx-translate/core";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
  imports: [TranslateModule, MatCardModule, MatButtonModule],
  declarations: [PageNotFoundComponent, UncaughtErrorComponent],
  providers: [],
})
export class ErrorRoutingModule {}
